export const dynamicFormScroll = () => {
  let element = document.getElementById("dynamic_form_container");
  element?.scrollTo({ top: 0, behavior: "smooth" });
};

export const convertDate = (inputFormat) => {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 *
 * @param {callBackFunc} func
 * @param {timer_in_milliseconds} delay
 * @returns callback function will be triggered after the user has finished typing. Note: works only for input onchange event
 */
export const debounceFunc = (func, delay = 500) => {
  let timer;
  return function (...args) {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

/**
 *
 * @param { searchText, data_to_search_from, embedded_key } param0
 * @returns a list of objects which has elements matching the given searchText
 */
export const getDataForSearchText = ({
  searchText = "",
  data_to_search_from = [],
  embedded_key = "",
}) => {
  if (searchText === "" || data_to_search_from?.length <= 0) {
    return [];
  }
  let returnData = [];
  for (const element of data_to_search_from) {
    const value = Object.values(element).some((item) => {
      const val = typeof item !== "string" ? item?.[0]?.[embedded_key] : item;
      return val?.toLowerCase().includes(searchText);
    });
    if (value) {
      returnData.push(element);
    }
  }
  return returnData;
};

const backgroundColors = [
  [240, 167, 48],
  [97, 170, 244],
  [255, 134, 70],
  [166, 47, 188],
  [0, 131, 142],
  [99, 185, 0],
  [6, 188, 181],
  [203, 77, 174],
  [142, 94, 252],
  [205, 86, 248]
]

export const getProfileNameExceptMrs = (firstName, colorCode) => {

  const randomNo = Math.floor(Math.random() * backgroundColors.length)

  const firstletter =
    firstName?.length && firstName.split(" ")[1]
      ? firstName.split(" ")[1].slice(0, 1).toUpperCase()
      : // else take the first letter of the name and make it uppercase
      firstName?.length
      ? firstName.slice(0, 1).toUpperCase()
      : "";
  const lastLetter =
    // first check if there is a space in the name then split the name else return nothing
    firstName?.length && firstName.split(" ")[2]
      ? firstName.split(" ")[2].slice(0, 1).toUpperCase()
      : ""

    if(firstName){
      return (
        <p className="profile_name pt-1" style={{ backgroundColor: `rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},0.08)`, color: `rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`, borderColor:`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}}>
      {firstletter ? firstletter : "A"}
      {lastLetter ? lastLetter : ""}
    </p>
  );
}

if(!firstName){
  return(
    <div
    style={{
      backgroundColor: `rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},0.08)` || "#512da1",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "5px",
      borderStyle:'solid',
      borderWidth:'1px',
      borderColor:`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)` || "#512da1",
    }}
  >
    <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="21.124" height="11.835" viewBox="0 0 21.124 11.835">
<g id="noun-users-943303" transform="translate(-98.001 -138.82)">
  <path id="Path_53935" data-name="Path 53935" d="M136.279,203.251a2.629,2.629,0,1,0-2.629-2.629A2.632,2.632,0,0,0,136.279,203.251Zm0-4.152a1.523,1.523,0,1,1-1.523,1.523A1.524,1.524,0,0,1,136.279,199.1Z" transform="translate(-34.155 -56.693)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
  <path id="Path_53936" data-name="Path 53936" d="M99.107,343.649a2.051,2.051,0,0,1,2.048-2.048h1.937c.058,0,.115,0,.172.007a.573.573,0,0,0,.436-.147.541.541,0,0,0,.176-.4.554.554,0,0,0-.492-.551c-.1-.009-.194-.014-.292-.014h-1.937A3.158,3.158,0,0,0,98,343.649v.227h1.106Z" transform="translate(0 -193.222)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
  <path id="Path_53937" data-name="Path 53937" d="M242.87,311.82h1.106v-1.362a2.318,2.318,0,0,1,2.316-2.316h2.136a2.318,2.318,0,0,1,2.316,2.316v1.362h1.106v-1.362a3.43,3.43,0,0,0-3.422-3.422h-2.136a3.433,3.433,0,0,0-3.422,3.422v1.362Z" transform="translate(-138.797 -161.166)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
  <path id="Path_53938" data-name="Path 53938" d="M466.607,340.48H464.67c-.054,0-.108,0-.161,0a.555.555,0,0,0-.359.957.545.545,0,0,0,.408.148c.037,0,.075,0,.113,0h1.937a2.051,2.051,0,0,1,2.048,2.048v.227h1.106v-.227a3.159,3.159,0,0,0-3.155-3.155Z" transform="translate(-350.637 -193.208)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
  <path id="Path_53939" data-name="Path 53939" d="M443.515,203.251a2.629,2.629,0,1,0-2.629-2.629A2.632,2.632,0,0,0,443.515,203.251Zm0-4.152a1.523,1.523,0,1,1-1.523,1.523A1.524,1.524,0,0,1,443.515,199.1Z" transform="translate(-328.514 -56.693)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
  <path id="Path_53940" data-name="Path 53940" d="M274.4,145.435a3.307,3.307,0,1,0-3.307-3.307A3.311,3.311,0,0,0,274.4,145.435Zm0-5.508a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,274.4,139.926Z" transform="translate(-165.835)" fill={`rgba(${backgroundColors[randomNo][0]},${backgroundColors[randomNo][1]},${backgroundColors[randomNo][2]},1)`}/>
</g>
</svg>
    </span>
  </div>
  )
}
};

export const randomProfileColors = () =>{
  
  const randomNo = Math.floor(Math.random() * backgroundColors.length)

  return backgroundColors[randomNo]
}

// helper function to find string similarity percentage
export const similarity = (s1, s2) => {
  if((s1 && s2) && (s1 != "NA" && s2 != "NA")){
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return Math.round(((longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)) * 100);
  } else{
    return 0;
  }
}
export const videoKYCAggregate = (document_uploaded, document_captured, preffered_kyc_keys) => {
  let sum = 0;
  let count = 0;
  let keysToConsider = [];
  let returnObj = { result: 0, keysToConsider :[] }
  if(document_uploaded && document_captured){
    for (const key of Object.keys(document_uploaded)) {
      if (!(key in document_captured) && !(typeof document_uploaded[key] === "string" && typeof document_uploaded[key] === "string")) {
        // console.log("false keys",key)
      }else if((document_captured[key] && document_captured[key] != "NA" && (typeof document_captured[key] == "string")) && (document_uploaded[key] && document_uploaded[key] != "NA" && (typeof document_uploaded[key] == "string"))){
        // console.log("pref", key, preffered_kyc_keys)
        if(preffered_kyc_keys.includes(key)){
            count=count+1;
            keysToConsider.push(key)
            sum = sum + similarity(document_captured[key],document_uploaded[key])
            // console.log("true keys", sum)
          }
        }
      
    }
    // console.log("pref", keysToConsider,preffered_kyc_keys, count, sum)
    let avg=Math.round(sum/count);
    returnObj.result = avg+"%"
    returnObj.keysToConsider = keysToConsider
    return returnObj;
    
  }else{
    returnObj.result = 0
    return returnObj;
    return {result : 0+ "%", keysToConsider: keysToConsider};
  }
}

function editDistance(s1, s2) {
  if(s1 && s2){
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();
  var costs = [];
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0)
        costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue),
              costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0)
      costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}
}

export const removeUndefinedFromString = (arr) => arr.join(" ")

export const  getAllSignerId = (config) =>{
  let arr= [];
  config?.forEach((ele)=>{
    ele?.form_groups?.map((items)=>{
      if(items?.form_elements.length == 1){
        if(items?.form_elements[0].type == 'recursive' && items?.form_elements[0].signer_recursion == true ){
          arr.push(items?.form_elements[0].name)
        }
      }
    })
  })
  return arr


}
const addressKeys = {
  "Residential" : ['address_line1','address_line2','landmark','district','city','pincode','state','country'],
  "Home" :['home_address_line1','home_address_line2','home_landmark','home_district','home_city','home_pincode','home_state','home_country'],
  "Office" : ['office_address_line1','office_address_line2','office_landmark','office_district','office_city','office_pincode','office_state','office_country',],
  "communication" :['communication_address_line1','communication_address_line2','communication_landmark','communication_district','communication_city','communication_pincode','communication_state','communication_country']
}

export const generateCommunicationAddress = (request_body,selectedData) =>{
  
  let keyField = selectedData.preferred_correspondence_address.split(' ')[0]
  let source_field = addressKeys[keyField],destinationField = addressKeys['communication']

  for(let i=0;i< source_field.length;i++){
    if(selectedData[`${source_field[i]}`]){
      request_body[`source_data.${destinationField[i]}`] = selectedData[`${source_field[i]}`]
    }
    
  }
}

export const autoFillData =(arr,selectedData) =>{
  let obj ={}
  arr?.forEach(item =>{
    if(selectedData[item?.source_field]){
    obj[`${item?.destination_field}`] = selectedData[item?.source_field]
    }else{
      obj[`${item?.destination_field}`] = ''
    }
  })
  return obj
}

export const getDependentsId = (saveData,guardianKey) => {
  let dependents = [],shouldBreak =false
  for (let i = saveData.length - 1; i >= 0; i--) {
    if (saveData[i].majority !== "Minor" && shouldBreak) break;
    if (saveData[i].majority === "Minor") {
      shouldBreak = true
      dependents.push(saveData[i].uid);
    }
  }
  return dependents;
};
// will return all guardians uid of a minor
export const getGuardiansId = (saveData,minorId) => {
  let dependents = []
  for (let i = 0; i <saveData.length; i++) {
    if (saveData[i].majority !== "Minor" && saveData[i]?.guardian_of?.includes(minorId)){
      dependents.push(saveData[i].uid);
    }
  }
  return dependents;
};

export const getDependentNamesByGuardianId = (saveData, guardianId) => {
  const guardian = saveData.find(app=>app.uid === guardianId)
  let dependents = ""
  for (let i = 0; i <saveData.length; i++) {
    if (saveData[i].majority === "Minor" && guardian?.guardian_of?.includes(saveData[i]?.uid)){
      dependents+=saveData[i].full_name+","
    }
  }
  return dependents.substring(0,dependents.length-1);
};

export const getDependentsNames = (dependentsArr,saveData,guardianKey) => {
  let dependentsNames = [],length = saveData.length;
  for (let i = dependentsArr.length - 1; i >= 0; i--) {
    for (let j = length-1; j >=0; j--) {
      if (dependentsArr[i] === saveData[j].uid) {
        dependentsNames.push(saveData[j][guardianKey]);
      }
    }
  }
  return dependentsNames;
};

export const updateSaveDataForGuardian = (saveData, editData, editIndex, guardianKey) => {
  let updatedData = []
  //* if person edited is guardian 
  if (editData.hasOwnProperty("guardian_of")){
    const dependents = saveData.slice(0, editIndex)
    
  }
  //* if person edited is minor
  else {
    let allGuardiansFound = false,currApplicantIndex = editIndex+1,guardians = []
    while (editIndex < saveData.length) {
      if (saveData[currApplicantIndex].hasOwnProperty("guardian_of")) {
        allGuardiansFound = true
        guardians.push(saveData[currApplicantIndex])
      }
      else if (!saveData[currApplicantIndex].hasOwnProperty("guardian_of")) {
        if(allGuardiansFound) break
      }
    }
    guardians = guardians.map(guardian => {
      if (guardian.hasOwnProperty("guardian_of")) {
        guardian.guardian_of = guardian.guardian_of.map(dependent => {
          if (dependent === editData[guardianKey])
            return 
        })
      }
    })
  }
}

export const getAllGuardians = (saveData) => {
  let guardians = []
  for (const applicant of saveData)
    if (applicant.hasOwnProperty("guardian_of") || applicant.majority.toLowerCase() !== "minor")
      guardians.push(applicant)
  return guardians
      
}
export const titleCase = (s) => {
  s = s.replaceAll("_", " ");
  let res = s.charAt(0).toUpperCase() + s.slice(1);
  return res;
};

export const findDuplicatesInArray = (array) =>
  array.filter((item, index) => array.indexOf(item) !== index);

export const setAppColor = (layoutSetting) =>{
  if(layoutSetting){
    document.documentElement?.style.setProperty(
      "--primary-color", layoutSetting?.["primary-color"]
      );
    }
}